module.exports = __webpack_public_path__ + "static/media/cursor-double.673fc3c9.svg";